'use strict';

import React, { Component } from 'react';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import moment from 'moment';
import numeral from 'numeral';
import uniqid from 'uniqid';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import { MAPS_API_KEY } from 'front_env';
import { action } from 'Shared/Routes';
moment.locale('fr');
numeral.locale('en');
const app = window.app;
const PIN_SIZE = window.innerWidth < 600 ? 64 : 48;
const CLUSTER_PIN_SIZE = 44;
const cluster_styles = [{
  width: CLUSTER_PIN_SIZE,
  height: CLUSTER_PIN_SIZE,
  className: bemit('c-cluster-icon', ['blue'])
}, {
  width: CLUSTER_PIN_SIZE,
  height: CLUSTER_PIN_SIZE,
  className: bemit('c-cluster-icon', ['blue'])
}, {
  width: CLUSTER_PIN_SIZE,
  height: CLUSTER_PIN_SIZE,
  className: bemit('c-cluster-icon', ['blue'])
}];
export default class EstablishmentMap extends Component {
  state = {
    gmap_id: uniqid(),
    script_id: 'google-map-script',
    script_ready: false
  };
  map_ref = React.createRef();
  markers = [];
  onBoundsChange = [];
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.loadScriptIfNeeded();
    component.fetchEstablishment();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_state.script_ready !== true && state.script_ready === true) {
      if (state.establishment) {
        component.startMapIfNeeded();
      }
    } else if (prev_state.establishment !== state.establishment) {
      component.startMapIfNeeded();
    }
    if (props.id !== prev_props.id) {
      component.fetchEstablishment();
    }
  }
  fetchEstablishment = async () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading_map: true
    });
    let url_slug;
    if (props['from-url']) {
      url_slug = document.location.pathname;
      if (url_slug.endsWith('/')) url_slug = url_slug.slice(0, -1);
      url_slug = url_slug.slice(url_slug.lastIndexOf('/') + 1);
    }
    try {
      var {
        establishment
      } = await ajaxRequest(action('GetEstablishmentForMap'), {
        data: props['from-url'] ? {
          slug: url_slug
        } : {
          id: props.id
        }
      });
    } catch (update) {
      return component.setState({
        ...update,
        loading_map: false
      });
    }
    component.setState({
      loading_map: false,
      establishment
    });
  };
  resetMap = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.placeMarkers(props.etablishments, true);
  };
  updateMap = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const etablishments = data.etablishments || [];
    component.placeMarkers(etablishments, true);
    if (etablishments.length && props['auto-scroll'] && component.map_ref?.current) {
      const is__visible = component.map_ref.current.getBoundingClientRect?.()?.top > 0;
      if (!is__visible) {
        component.map_ref?.current?.parentElement?.scrollIntoView?.({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  loadScriptIfNeeded = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Script already appended and loaded
    if (window.google?.maps?.Map) {
      return component.setState({
        script_ready: true
      });
    }
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('async', true);
    script.setAttribute('defer', true);
    script.setAttribute('id', state.script_id);
    script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + MAPS_API_KEY + '&libraries=places&loading=async');
    script.addEventListener('load', function () {
      component.setState({
        script_ready: true
      });
    });
    script.addEventListener('onError', function (e, error) {
      console.error('error loading gmap', error);
    });
    document.body.appendChild(script);
  };
  startMapIfNeeded = (force = false) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!window.google?.maps?.Map) return;
    const map_div = document.getElementById('gmap-' + component.state.gmap_id);
    component.map = new window.google.maps.Map(map_div, {
      zoom: 6,
      center: {
        lat: 46.5674172,
        lng: 1.4753071
      },
      // France
      gestureHandling: 'cooperative'
    });
    component.map.addListener('bounds_changed', component.handleBoundsChange);
    component.placeMarkers(props.etablishments);
  };
  handleBoundsChange = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component.map) return;

    // Nothing to call
    if (component.onBoundsChange?.length > 0 === false) return;
    const cb = component.onBoundsChange[0];
    component.onBoundsChange = component.onBoundsChange.slice(1);
    if (cb instanceof Function) {
      cb();
    }
  };
  placeMarkers = (reset_if_no_results = false) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component.map || !window.google.maps || !state.establishment) return;
    if (component.cluster) {
      component.cluster.clearMarkers();
      component.markers = [];
    }
    const bounds = new window.google.maps.LatLngBounds();
    const etablishment = state.establishment;
    let marker = component.markers[etablishment.id],
      id = etablishment.id;
    const is__invalid = !etablishment?.geometry?.location?.lat || !etablishment?.geometry?.location?.lng;
    if (is__invalid) {
      return console.error('Invalid marker position', etablishment);
    }
    const position = new window.google.maps.LatLng(etablishment.geometry.location.lat, etablishment.geometry.location.lng);
    marker = {
      visible: true,
      marker: new window.google.maps.Marker({
        position: position,
        map: component.map,
        title: etablishment.name,
        icon: {
          url: '/images/map_pin.svg',
          scaledSize: new window.google.maps.Size(PIN_SIZE, PIN_SIZE) // pixels
        }
      })
    };

    bounds.extend(position);

    // Toggle off a marker :
    // marker.visible = false;
    // marker.marker.setMap(null);

    // Toggle on a marker :
    // marker.visible = true;
    // marker.marker.setMap(component.map);

    if (!marker.tooltips) {
      let tooltip = {
        open: false
      };
      let content = ['<div class="c-gmap__tooltip">', '<img src="/images/logo-mywo.svg" alt="myWo" ', 'class="c-gmap__tooltip-logo" ', 'height="20" width="35" ', '/>', etablishment.name.replace('myWO', '').replace('myWo', '').replace('mywo', ''), '</div>'].join('');
      tooltip.infowindow = new window.google.maps.InfoWindow({
        content: content
      });
      marker.tooltips = [tooltip];
      if (!component.markers[id]) {
        marker.marker.addListener('click', function () {
          let global_tooltip = marker.tooltips[0];
          global_tooltip.infowindow.open(component.map, component.markers[id].marker);
        });
      }
    }
    component.markers[id] = marker;
    component.map.fitBounds(bounds);
    component.onBoundsChange.push(function setZoom() {
      if (component.map.getZoom() != 10) {
        component.map.setZoom(12);
      }
    });
    const markers = Object.keys(component.markers).map(id => component.markers[id].marker).filter(marker => marker !== undefined);
    component.cluster = new MarkerClusterer(component.map, markers, {
      gridSize: 40,
      styles: cluster_styles
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    let modifiers = (props.bemit || []).slice(0).concat(['establishment']);
    const output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-gmap', modifiers),
      id: 'gmap-' + state.gmap_id,
      key: props['search-id'],
      ref: component.map_ref
    }, loader);
    if (props['section-id']) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, output, /*#__PURE__*/React.createElement("div", {
        className: "c-gmap__anchor",
        id: props['section-id']
      }));
    }
    return output;
  }
}
